interface Props {
  name: string;
  size?: number;
  className?: string;
}

/** Avatar circolare con iniziali + gradient deterministico per nome. */
export function Avatar({ name, size = 28, className = "" }: Props) {
  const initials = name
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  const hue = Math.abs(hash(name)) % 360;
  const bg = `linear-gradient(135deg, hsl(${hue} 70% 60%), hsl(${(hue + 60) % 360} 70% 50%))`;

  return (
    <div
      className={`grid place-items-center rounded-full text-white font-semibold ${className}`}
      style={{
        width: size,
        height: size,
        background: bg,
        fontSize: size * 0.42,
      }}
    >
      {initials || "?"}
    </div>
  );
}

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return h;
}
